import { IconButton, StarIcon } from '@buffer-mono/popcorn'

import { useUpdateAccountPreferences } from '~publish/pages/Settings/Preferences/hooks/useUpdateAccountPreferences'

import { SCHEDULE_OPTIONS } from './constants'
import type { ScheduleOption } from './types'

import type { JSX } from 'react'

export const ScheduleOptionDefaultMarker: React.FC<{
  isDefault: boolean
  isDisabled: boolean
  option: ScheduleOption
  className?: string
}> = ({ option, isDefault, isDisabled, className }): JSX.Element | null => {
  const [updateAccountPreferences, { loading }] = useUpdateAccountPreferences()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault()
    if (loading || isDefault) return
    void updateAccountPreferences({
      variables: {
        input: {
          defaultScheduleOption: option,
        },
      },
    })
  }

  const fill = isDefault ? 'currentColor' : 'none'
  const hideButton = isDisabled && !isDefault
  const optionLabel = SCHEDULE_OPTIONS[option].label
  const label = isDefault
    ? `${optionLabel} is the default`
    : `Set as default: ${optionLabel}`

  if (hideButton) return null

  return (
    <IconButton
      variant="secondary"
      className={className}
      disabled={isDisabled}
      onClick={handleClick}
      label={label}
      tooltip={
        isDefault
          ? `${optionLabel} is the default posting action.`
          : `Set as default posting action: ${optionLabel}.`
      }
      size="small"
    >
      <StarIcon fill={fill} />
    </IconButton>
  )
}
